import { durationToUnit } from '@cast/utils';

import { DateRangeFilter } from '@cast/shared-date-ui';

export const RELIABILITY_REFETCH_INTERVAL: Partial<
  Record<DateRangeFilter, number>
> = {
  [DateRangeFilter.Last15Mins]: durationToUnit('1m', 'ms'),
  [DateRangeFilter.Last30Mins]: durationToUnit('1m', 'ms'),
  [DateRangeFilter.LastHour]: durationToUnit('1m', 'ms'),
  [DateRangeFilter.Last6Hours]: durationToUnit('10m', 'ms'),
  [DateRangeFilter.Last24Hours]: durationToUnit('10m', 'ms'),
};
